import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';

interface RegisterClickData {
  signature: string;
}

const registerListingCall = (makeCall: MakeCall) => (
  listingId: number,
  data: RegisterClickData,
) =>
  makeCall<null>('POST', `${APIV2_URL}/listing/${listingId}/register-click`, {
    data,
  });

export default registerListingCall;
